export const ApiDef_RuntimeSmartDoc = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map